import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './i18n';
import './styles/style.sass';

ReactDOM.render(<App />, document.getElementById('root'));
